import { IMO } from "./carriers.js";
import { buildFormSchemaForCarriers, CARRIER_VALUE_TO_IMO, getReadinessChecklist, resolveFormRequirements, } from "./forms.js";
const SHARED_IDENTITY_FIELDS = ["firstName", "lastName", "email", "phone"];
const PROVIDER_INTAKE_FIELDS = {
    [IMO.PREMIER_PRODUCERS_GROUP]: [
        ...SHARED_IDENTITY_FIELDS,
        "ssn",
        "dateOfBirth",
        "npn",
        "state",
        "requestedCommissionLevel",
        "managerName",
        "managerEmail",
        "hasRelease",
        "releaseUpload",
        "message",
        "trainingStartDate",
        "selectedCarriers",
    ],
    [IMO.PINNACLE]: [
        ...SHARED_IDENTITY_FIELDS,
        "npn",
        "ssn",
        "dateOfBirth",
        "isPrincipal",
        "agencyEIN",
        "agencyNPN",
        "statesToSell",
        "address",
        "addressLine2",
        "city",
        "state",
        "zipCode",
        "sameAsBusinessAddress",
        "businessAddress",
        "businessAddressLine2",
        "businessCity",
        "businessState",
        "businessZipCode",
        "selectedCarriers",
    ],
    [IMO.HEARTLAND]: [
        ...SHARED_IDENTITY_FIELDS,
        "npn",
        "ssn",
        "dateOfBirth",
        "requestedCommissionLevel",
        "selectedCarriers",
    ],
};
const PREVIEW_SECTION_MINUTES = {
    nipr_identity: 2,
    license_identity: 2,
    carrier_contracting: 1,
    carrier_intake: 3,
    carrier_profile: 4,
    tax_information: 3,
    banking_information: 3,
    additional_documents: 1,
    application_review: 2,
};
const STATIC_STEP_MINUTES = 4;
export function getProviderIntakeFields(imo) {
    return [...(PROVIDER_INTAKE_FIELDS[imo] ?? SHARED_IDENTITY_FIELDS)];
}
export function getCarrierStepPreview(carriers = []) {
    const requirements = resolveFormRequirements(carriers);
    const schema = buildFormSchemaForCarriers(carriers);
    const dynamicSectionIds = new Set([
        "nipr_identity",
        "license_identity",
        "carrier_contracting",
        "carrier_intake",
        "carrier_profile",
        "tax_information",
        "banking_information",
        "additional_documents",
        "application_review",
    ]);
    const sections = schema.sections
        .filter((section) => dynamicSectionIds.has(section.id))
        .map((section) => section.title);
    const checklist = getReadinessChecklist(requirements);
    const estimatedMinutes = STATIC_STEP_MINUTES +
        schema.sections
            .filter((section) => dynamicSectionIds.has(section.id))
            .reduce((total, section) => total + (PREVIEW_SECTION_MINUTES[section.id] ?? 2), 0);
    return {
        sections,
        checklist,
        estimatedMinutes,
        imos: requirements.imos,
        carrierCount: carriers.filter((carrier) => Boolean(CARRIER_VALUE_TO_IMO[carrier])).length,
    };
}
